import styled, { css } from 'styled-components'
import theme from 'theme_'
import { CommonLinkButton } from 'components/Button'
import { Font12 } from 'components/Typography'
import Icon from '@mdi/react'
import { HomeConfigurationContainer, StyledConfigHeader } from '../styles'

export const StyledToggleConfigButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`

export const StyledToggleConfigButton = styled(CommonLinkButton)<{
  isActive: boolean
}>`
  ${Font12};
  text-transform: uppercase;
  padding: 4px 0;
  line-height: 24px;
  border: 1px solid ${theme.colors.horizonOrange};
  width: 268px;

  &:first-child {
    border-right: none;
    border-radius: 8px 0 0 8px;
  }

  &:last-child {
    border-left: none;
    border-radius: 0 8px 8px 0;
  }

  ${(p) =>
    p.isActive &&
    `
      background-color: ${theme.colors.horizonOrange};
      color: ${theme.colors.white}
    `}
`

export const HomeConfigButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const HomeConfigRowStyle = css`
  height: auto;
`

export const HomeConfigModalProgressBarContainer = styled.div`
  width: calc(100% - 40px);
  height: 6px;
  border-radius: 8px;
  background-color: white;
  overflow: hidden;
`

export const HomeConfigModalProgressBar = styled.div<{ progress: number }>`
  width: ${({ progress }) => progress}%;
  background-color: ${theme.colors.horizonOrange};
  height: 100%;
`

export const HomeConfigUploadedIcon = styled(Icon)`
  width: 64px;
  height: 64px;
  color: ${theme.colors.successGreen};
`

export const HomeConfigUploadedSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const HomeConfigUploadedSuccessTitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  color: ${theme.colors.otterWarmBlack};
`

export const HomeConfigUploadedSuccessFilenameWrapper = styled.div`
  height: 128px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`

export const HomeConfigUploadedSuccessFilename = styled.span`
  word-break: break-all;
`

export const HomeConfigActionsCellContainer = styled.div`
  display: flex;
  justify-content: left;
`

export const HomeConfigActionsCellBody = styled.div<{ isLoading?: boolean }>`
  display: ${({ isLoading = false }) => (isLoading ? 'none' : 'flex')};
  align-items: center;
  min-width: 150px;
  width: 100%;
`

export const HomeConfigActionCellProgressBarContainer = styled(
  HomeConfigModalProgressBarContainer
)`
  box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.4);
  width: 120px;
`

export const HomeConfigActionCellProgressBar = styled(
  HomeConfigModalProgressBar
)``

export const HomeConfigFilesContainer = styled(HomeConfigurationContainer)``

export const ConfigTitleHeaderContaier = styled.div``

export const HomeConfigRadioTilesContainer = styled.div`
  width: 100%;
  order: 1;
  @media ${theme.devices.tablet} {
    order: unset;
    width: 50%;
    min-width: 350px;
    margin: 0 auto;
  }
`

export const HomeConfigFilesHeaderContainer = styled(StyledConfigHeader)`
  flex-wrap: wrap;
`

export const HomeConfigFilesHeaderTitle = styled.h2`
  order: 2;
  @media ${theme.devices.tablet} {
    order: unset;
  }
`

export const HomeConfigFilesMobileProgressContainer = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background-color: ${theme.colors.lightGrey};
  overflow: hidden;
`

export const HomeConfigFilesMobileDeployingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 17px;

  > span {
    color: ${theme.colors.otterWarmBlack};
    font-weight: 325;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 17px;
  }
`

export const MobileHomeConfigDeployButton = styled(CommonLinkButton)``
